import { render, staticRenderFns } from "./SpoiledBanner.vue?vue&type=template&id=44eced4a&scoped=true&"
import script from "./SpoiledBanner.vue?vue&type=script&lang=js&"
export * from "./SpoiledBanner.vue?vue&type=script&lang=js&"
import style0 from "./SpoiledBanner.vue?vue&type=style&index=0&id=44eced4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44eced4a",
  null
  
)

export default component.exports